const featuredBrands = () => {
    $('.slick-brands').slick({
        nextArrow: '<i class="slickCustomNext" aria-hidden="true"><svg height="24px" width="24px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.39 48.77"><title>arrow-right</title><g data-name="Layer 2"><g data-name="Layer 1"><path d="M1,48.77a1,1,0,0,1-.71-1.71L23,24.39.29,1.71A1,1,0,0,1,1.71.29L25.09,23.68a1,1,0,0,1,0,1.41L1.71,48.48A1,1,0,0,1,1,48.77Z"/></g></g></svg></i>',
        prevArrow: '<i class="slickCustomPrev" aria-hidden="true"><svg height="24px" width="24px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.39 48.77"><title>arrow-left</title><g data-name="Layer 2"><g data-name="Layer 1"><path d="M24.39,48.77a1,1,0,0,1-.71-.29L.29,25.09a1,1,0,0,1,0-1.41L23.68.29a1,1,0,0,1,1.41,1.41L2.41,24.39,25.09,47.07a1,1,0,0,1-.71,1.71Z"/></g></g></svg></i>',
        autoplay: true,
        slidesToShow: 6,
        slidesToScroll: 6,
        infinite: true,
        responsive: [{
            breakpoint: 1025,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows: false
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows: false
            }
        }]
    });
}

export {
    featuredBrands
}
